module.exports = __webpack_public_path__ + "static/media/firmaYa.74fe2492.jpg";